<template>
  <div class="main">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layoutContainerMain'
}
</script>
<style lang="scss" scoped>
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 0 20px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/index.vue